@if (cow) {
  <div>
    <agr-summary-card-horizontal
      class="spacing--margin-bottom flex__child--col-2 col-2"
      title="{{ 'dairyresults.cow-details.properties.title' | translate }}"
      [canExpand]="true"
      [items]="cowProperties"
    >
    </agr-summary-card-horizontal>
    <mat-expansion-panel [disabled]="cow.mutations?.calvings?.length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.calvings.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.calvings?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="calvingTableConfig"> </agr-table>
    </mat-expansion-panel>
    <mat-expansion-panel [disabled]="cow.mutations?.dayProductions?.length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.day-production.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.dayProductions?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="dayProductionTableConfig"> </agr-table>
    </mat-expansion-panel>
    <mat-expansion-panel [disabled]="cow.mutations?.lactationProductions?.length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.lactation-production.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.lactationProductions?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="lactationProductionTableConfig"> </agr-table>
    </mat-expansion-panel>
    <mat-expansion-panel [disabled]="cow.mutations?.predictions?.length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.prediction.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.predictions?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="predictionTableConfig"> </agr-table>
    </mat-expansion-panel>
    <mat-expansion-panel
      [disabled]="cow.mutations?.additions?.length === 0 && cow.mutations?.removals?.length === 0"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.add-remove.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.additions?.length + cow.mutations?.removals?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="addRemoveTableConfig"> </agr-table>
    </mat-expansion-panel>
    <mat-expansion-panel [disabled]="cow.mutations?.productionStatusMutations?.length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.production-status.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.productionStatusMutations?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="productionStatusTableConfig"> </agr-table>
    </mat-expansion-panel>
    <mat-expansion-panel [disabled]="cow.mutations?.inseminations?.length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>{{
          'dairyresults.cow-details.inseminations.title' | translate
        }}</mat-panel-title>
        <mat-panel-description
          >{{ cow.mutations?.inseminations?.length }}
          {{ 'dairyresults.cow-details.records' | translate }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <agr-table [config]="inseminationTableConfig"> </agr-table>
    </mat-expansion-panel>
  </div>
}
